// Route Code Edited 3/24/26
/**
 * Route + Discount Ninja Compatibility Handler
 *
 * Discount Ninja marks Route's cloned checkout button [data-route-cloned-button]
 * with its own click-interception classes/attr, causing stopImmediatePropagation()
 * to block Route's checkout handler. This script strips those markers and keeps
 * them stripped via a MutationObserver.
 *
 * Usage:
 *   <script src="{{ 'route-discount-ninja-handler.js' | asset_url }}" defer="defer"></script>
 */

(function stripDiscountNinjaFromRouteButton() {

  const SELECTOR   = '[data-route-cloned-button]';
  const DN_CLASSES = ['limoniapps-discountninja-checkoutbutton', 'limoniapps-discountninja-block-stop'];
  const DN_ATTR    = 'data-limoniapps-discountninja-eventhandler-click';

  function hasDnMarkers(btn) {
    return DN_CLASSES.some(c => btn.classList.contains(c)) || btn.hasAttribute(DN_ATTR);
  }

  // Disconnect before mutating to avoid an infinite mutation loop, then reconnect
  function strip(btn, observer) {
    observer.disconnect();
    DN_CLASSES.forEach(c => btn.classList.remove(c));
    btn.removeAttribute(DN_ATTR);
    observer.observe(btn, { attributes: true, attributeFilter: ['class', DN_ATTR] });
  }

  function watchButton(btn) {
    if (btn._routeDnWatched) return;
    btn._routeDnWatched = true;

    const observer = new MutationObserver(() => {
      if (hasDnMarkers(btn)) strip(btn, observer);
    });

    strip(btn, observer);
  }

  // Route renders asynchronously, so watch for the button being injected
  const domObserver = new MutationObserver(() => {
    document.querySelectorAll(SELECTOR).forEach(watchButton);
  });

  domObserver.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll(SELECTOR).forEach(watchButton);
  setTimeout(() => domObserver.disconnect(), 15000);

})();